import { createSelector } from 'reselect';

import {
  selectedCourseSelector,
  courseValidationSelector,
  selectedSchoolSelector,
} from '../../../reducers/selectors';

const courseAttendanceType = state => state.builder.ui.course?.attendance;
const periodOrder = state => state.builder.ui.period?.periodOrder;

const schoolSelector = createSelector(
  selectedCourseSelector,
  courseValidationSelector,
  selectedSchoolSelector,
  courseAttendanceType,
  periodOrder,

  (selectedCourse, validatedCourse, school, courseAttendance, periodOrderNumber) => {
    let selectedSchool;
    const supportedSchool = school?.supported === true;
    const blockedSchool = school?.blockedReasons.length > 0;

    const { REACT_APP_ENABLE_UPCOMING_PERIODS: ENABLE_UPCOMING_PERIODS } = process.env;
    const enableUpcomingPeriods = ENABLE_UPCOMING_PERIODS === '1';

    if (selectedCourse?.underReview === true) {
      selectedSchool = 'underReview';
    } else if (validatedCourse !== false) {
      if (periodOrderNumber === 1 || enableUpcomingPeriods)
        selectedSchool = courseAttendance === 'FullTime' ? 'fullTimeCourse' : 'notFullTimeCourse';
      else selectedSchool = 'invalidCourse';
    } else if (validatedCourse === false) selectedSchool = 'unvalidatedPeriodsData';
    else if (school.supported === false) selectedSchool = 'unsupportedSchool';
    else if (blockedSchool) selectedSchool = 'frenchRegulationBlockedSchool';
    else if (school.campuses.length > 1 && supportedSchool && !blockedSchool)
      selectedSchool = 'multipleCampuses';
    else if (school.campuses.length === 1 && supportedSchool && !blockedSchool)
      selectedSchool = 'singleCampus';
    return selectedSchool;
  },
);

export default schoolSelector;
